//import { all } from "q";
var allH = [];
var tallestP = 0;
function resizeWindow(){
	var homeheight = $(window).height() * 1;
	$('.top-content-home').css('height', $(window).height() + 'px');
	//Home 
	$('body#home .header-img .sym-slide').height($(window).height());
	pressH();
}
function pressH() {
	allH = [];
	$('.giving-back').each(function(){
		$(this).find('.top-cont').css('height','auto');
		allH.push($(this).find('.top-cont').height());
	});
	tallestP = allH.reduce(function(a,b){
		return a > b ? a : b;
	},{});
	$('.giving-back').each(function(){
		$(this).find('.top-cont').css('height',tallestP + 10 +'px');
	});
}
function scrollDown(){

}
$('#booking-form select').select2();

function navisEmailSignup(formID) {

	$.post(site_url + 'ajax/emailsignup.php',$("#" + formID).serialize(), function(data){
		if(data.error) {
			$("#email-error").html(data.msg);

		} else {
			//ga('send', 'event', 'form', 'click', 'specials');
			$("#"+formID).html('<p>Thank You</p>');

		}
	},'json');

}

$(document).ready(function () {


	//cms form system associate
	if(document.getElementById('id_0_652')){
		document.getElementById('id_0_652').addEventListener('change', function(){
			let propertyValue = this.value;
			let sendtoemail = '';
			let ccemail = [];
			switch(propertyValue) {
			case 'Bodega Bay Lodge':
				sendtoemail = 'support@bodegabaylodge.com';
				ccemail = ['pc@bodegabaylodge.com']
				break;
			case 'Harvest Inn':
				sendtoemail = 'support@harvestinn.com';
				ccemail = ['pc@harvestinn.com']
				break;
			case 'Hotel Drisco':
				sendtoemail = 'support@hoteldrisco.com';
				ccemail = ['pc@hoteldrisco.com']
				break;
			case 'Lafayette Park Hotel & Spa ':
				sendtoemail = 'support@lafayetteparkhotel.com';
				ccemail = ['pc@lafayetteparkhotel.com']
				break;
			case 'Monterey Plaza Hotel':
				sendtoemail = 'support@montereyplazahotel.com';
				ccemail = ['pc@montereyplazahotel.com']
				break;
			case 'Napa Valley Lodge':
				sendtoemail = 'support@napavalleylodge.com';
				ccemail = ['pc@napavalleylodge.com']
				break;
			case 'Stanford Park Hotel':
				sendtoemail = 'support@stanfordparkhotel.com';
				ccemail = ['pc@stanfordparkhotel.com']
				break;
			case 'Woodside Hotel Group':
				sendtoemail = 'support@woodsidehotelgroup.com';
				ccemail = ['']
				break;
			default:
				sendtoemail = 'support@woodsidehotelgroup.com';
				ccemail = ['']
			}
			document.getElementById('sendto_652').setAttribute('value',sendtoemail)
			for(let i = 0; i < ccemail.length; i++){
				let newInputCC = document.createElement('input')
				newInputCC.setAttribute('type','hidden');
				newInputCC.setAttribute('name','emailcc[]');
				newInputCC.setAttribute('id','cc' + i);
				newInputCC.setAttribute('value',ccemail[i]);
				document.getElementById('form_id-652').insertBefore(newInputCC,document.getElementById('sendto_652'))
			}
		})
	}



	// Remove atr
    $('#secondary-nav').removeAttr('aria-label');
    $('#primary-nav').removeAttr('aria-label');
    
    $('.slick-prev').removeAttr('aria-label');
    $('.slick-next').removeAttr('aria-label');  

	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	setTimeout(() => {
		$('.top-content-home.clearfix').css('opacity','1');
	}, 200);

    //rated hotels home
    // $(".new-trip-section .blog-post-content .box1").wrapAll("<div class='col-sm-12' />");
	// $(".new-trip-section .blog-post-content .box2").wrapAll("<div class='col-sm-12' />");

	//Call function with browser is resized.
    $(window).resize(function (event) {
         resizeWindow();
    });
	resizeWindow();
	if(document.getElementsByClassName('js-booking-select')[0]){
		document.getElementsByClassName('js-booking-select')[0].addEventListener('click', function(){
			if(!document.getElementsByClassName('js-booking-list')[0].classList.contains('ready')){
				document.getElementsByClassName('js-booking-list')[0].classList.add('ready');
			} else {
				document.getElementsByClassName('js-booking-list')[0].classList.remove('ready');
			}
		});

	}
	
	
	if($('.notice-payment').length > 0) {
		$('#header').addClass('notice');
	}
    //Acts when scroll down page.
    $(window).scroll(function (event) {
    	scrollDown();
		var top = ($('#header-img').height());
		if ($(this).scrollTop() > top) {
			$('#content .content .sub-menu ul').addClass('navbar-fixed');
			$('#header').addClass('scroll', 200);
		} else {
			$('#content .content .sub-menu ul').removeClass('navbar-fixed');
			$('#header').removeClass('scroll', 200);
		}
		var notice = 35;
		if(($(this).scrollTop() > notice) && ($('.notice-payment').length > 0)) {
			$('#header').removeClass('notice', 200);
		} else if($('.notice-payment').length > 0) {
			$('#header').addClass('notice', 200);
		}
	});
	 
/*
	setTimeout(function(){
		$( ".headline-only" ).animate( { zoom: "90%" }, { queue: false, duration: 1500 }).fadeOut(2000);
	}, 3000);
*/
	
	
	
	//Hashtag smooth scroll
    if(window.location.hash) {
        setTimeout(function() {
			var hash = window.location.hash;
			 $('body, html').animate({
	        scrollTop: $(hash).offset().top-70}, 800);
        }, 500);
	}
	
	if($('#home').length > 0) {
		$('.top-content-home').fullscreenBackground();
	}
    
	$('#content .content li, #home ul.sym-inline-list li').wrapInner('<span></span>');
	
	$('.btnSubmit').click(function(){
		if($('.check-required :checkbox:checked').length == 0) {
			$('.location-error').show();
		} else {
			$('.location-error').hide();
		}
	});

	// Main Nav Dropdown
    $("#primary-nav li").hover(function(){
        $(this).addClass("hover");
        $('ul.submenu',this).fadeIn(200);
    }, function(){
        $(this).removeClass("hover");
        $('ul.submenu',this).fadeOut(200);
    });
    
    if($('#home').length > 0) {
	    $('#header #primary-nav ul li ul.submenu li a').removeClass('active');
	    $('.tablet-primary ul.submenu li a').removeClass('active');
    }
    
    /*** tablet nav ***/
    $('.menu-trigger').click(function(){
		if ($(this).hasClass('open')){
			$('#header .tablet-primary').fadeOut(); 
			var text = $(this).text();
			$('.menu-text').text('Menu');
			$('.menu-holder').removeClass('close');
		} else {
			$('#header .tablet-primary').fadeIn();
			$('.menu-text').text('Close');
			$('.menu-holder').addClass('close');
			if($('.navigation ul li a').hasClass('active')){
				$(".item-open").get(0).scrollIntoView(false);
			}
		}
	});
	$('.menu-trigger').click(function(){
		$(this).toggleClass('open');
	});
	
	//Full desktop subnav
	$('#header #primary-nav ul li').wrapInner('<span class="forced-sub"></span>'); 
	
	//SUBNAVIGATION

	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, 'easeOutQuart', function() {}).addClass('menu-open');

	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function(event) {
		if ( $(this).parent().children(".sub-sub-menu").length > 0 ) {

            event.preventDefault();

           	if ($(this).next().hasClass('menu-open')) {
	            $(this).parent().parent().removeClass('open');
	            $(this).parent().removeClass('item-open');
                $(this).next().slideUp(300, 'easeOutQuart').removeClass('menu-open');
                console.log("close");
            } else {
	            $(this).parent().parent().addClass('open');
	            $(this).parent().addClass('item-open');
                $('.sub-sub-menu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
                $(this).next().slideDown(300, 'easeOutQuart', function() {}).addClass('menu-open');
                console.log("open");
            }
        }
    });


        // Navigation Available Max-Height
    var topSiblings = $('.navigation .inner').prevAll().outerHeight() + 20; // Add 20px padding-top
    var bottomSiblings = $('.navigation .inner').nextAll().height();
    var viewportHeight = $(window).height() * 0.95; // Substract 5% for top buttons

    var navigationHeight = viewportHeight - (bottomSiblings + topSiblings);
    $('.navigation .inner > ul').css("max-height", navigationHeight); 
    // Remove the mobile redirect on tablet nav
    $(".tablet-primary .navigation .inner li a").each(function() {
	    this.href = this.href.replace('/m/', '/');
	});
	/*** end tablet nav ***/

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function(event) {
	    $('body, html').animate({
	        scrollTop: $(window).height()-$('header').outerHeight()},
	        800, 'easeOutExpo');
	});
	
	$('#all-properties').find('.toggle-copy').click(function(){
		if($(this).hasClass('open')) {
			$(this).removeClass('open');
		} else {
			$('.toggle-copy').removeClass('open');
			$(this).addClass('open');
		}
		$(this).closest(".each-prop").next('.full-copy').slideToggle("slow");
	}); 
	
	$('.blogs').find('.toggle-copy').click(function(){
		if($(this).hasClass('open')) {
			$(this).removeClass('open');
		} else {
			$('.toggle-copy').removeClass('open');
			$(this).addClass('open');
		}
		$(this).siblings('.full-copy').slideToggle("slow");
	}); 
	
	//Show More in Specials
	$('#learn-more').click(function(){
		if($(this).hasClass('show-all')) {
			$('.full').slideUp(300);
			$(this).removeClass('show-all');
		} else {
			$('.full').slideDown(500);
			$(this).addClass('show-all');
		}
	});
	
	/*** start homepage trio tabs ***/
	
	// below to auto run
/*
	var clicked_tab = false;
	var lis = $('#home ul.tabs-menu li');
	var tab_id = 1;
	var changeTab = function(){
		if(clicked_tab == false) {
			//console.log(tab_id);
			$('#home .tabs-menu a').removeClass('active');
			$("#" + tab_id).addClass('active');
			var tab = $("#" + tab_id).attr("href");
			$("#home .tab-content").not(tab).fadeOut(500);
			$(tab).fadeIn(700);
			$(".slides-trio, .slides-trio-1, .slides-trio-2").slick("setPosition");
			tab_id=tab_id%lis.length + 1;
		}
	}
      
	var intervalID = window.setInterval(changeTab, 4000);
*/

	// home gallery new js
	//tabs
	$('.js-slick-tabs').slick({
		accessibility:false,
		fade:true,
	});
	
	$(".tabs-menu a").click(function(event) {
        event.preventDefault();
        $('.tabs-menu a').each(function(){
			$(this).removeClass("active");
		})
        $(this).addClass("active");
		var tab = $(this).attr("href");
		
		$(".tab-content").not(tab).fadeOut(500);
		$('.js-slick-tabs').addClass('smooth-fade');
		$(tab).fadeIn(500, function(){
			$('.js-slick-tabs').slick('unslick');
		});
		setTimeout(function(){
			$('.js-slick-tabs').slick({
				accessibility:false,
				fade:true,
				
			});
			$('.js-slick-tabs').removeClass('smooth-fade');
		},550);

	});
	//home gallery paginator and counter
	$('.tab-content').each(function(){
		var numItems = $(this).find('.item').length;
		$(this).find('.pagingInfo').html('1 of ' + numItems);
	});
	//home gallery slick change event
	$('.js-slick-tabs').on('afterChange', function(event, slick, currentSlide, nextSlide){
		var thisCurrentSlide = currentSlide + 1;
		var currentItems = $(this).find('.item').length;
		$(this).siblings().find('.pagingInfo').html(thisCurrentSlide + ' of ' + currentItems);
	});
	//bottom buttons events to swipe
	$('.newPrev').click(function(){
		$('.js-slick-tabs').slick('slickPrev');
	});
	$('.newNext').click(function(){
		$('.js-slick-tabs').slick('slickNext');
	});

    // kill auto run
/*
    $('.trio-home').click(function(event){
	    clicked_tab = true;
    });
*/
    /*** end homepage trio tabs ***/
    
    $("#specials .tabs-menu a").click(function(event) {
        event.preventDefault();
        $('.tabs-menu a').removeClass("active");
        $(this).addClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
        var extaSpecials = $('#header-img').height();
        $('body, html').animate({scrollTop: $('.intro-copy').offset().top+extaSpecials-200}, 800);

        
    });
    
	$('.rfp-show').click(function(){
		$('.rfp-holder').slideToggle();
	});
	
	$("a[href='" + window.location.hash + "']").parent(".trigger").click();

	//Slick Slider
	$('.sym-slides').slick();
	
	$('.sym-header').slick({
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 500, 
		fade: true,
		accessibility: false
	});

/*
	$('.history-slides').slick({ 
		fade: false,
		dots: true,
		arrows: true,
		autoplay: false,
        autoplaySpeed: 4000, 
        speed: 500, 
        accessibility: false,
		appendDots: $('.history-nav'),
		customPaging: function(slider, i) {
	        var title = $(slider.$slides[i]).data('title');
	        return '<a>'+title+'</a>';
	    }
	});
*/

	
	

	$('.history-slides').slick({
		slidesToShow: 1,
	    slidesToScroll: 1,
	    fade: true,
	    asNavFor: '.history-nav',
	    dots: false,
	    arrows:true,    
	    appendDots: $('.history-nav'),
	    centerMode: false,
/*
		customPaging: function(slider, i) {
	        var title = $(slider.$slides[i]).data('title');
	        return '<a>'+title+'</a>';
	    }
*/
	});
	$('.history-nav').slick({
		slidesToShow: 3,
	    slidesToScroll: 1,
	    asNavFor: '.history-slides',
	    dots: false,
	    arrows:false,
	    centerMode: false,
	    focusOnSelect: true,
/*
	    customPaging: function(slider, i) {
	        var title = $(slider.$slides[i]).data('title');
	        return '<a>'+title+'</a>';
	    }
*/
	});

	$('.slick-press').slick({
		slidesToShow: 1,
	    slidesToScroll: 1,
	    fade: true,
	    dots: true,
	    arrows:false,    
	    centerMode: false,
		accessibility:false
	});
	var firstPublicationjs = document.getElementsByClassName('month');
    var firstPublication = $('.press-releases .month:first-child');
	var selectContainer = document.getElementById('select-container')
	

	/* $('.slick-press .slick-dots li button').prepend('0');
	
	// var $status0 = $('.pagingInfo');
	// var $slickElement0 = $('.slides-trio'); 
	// $slickElement0.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    // 	//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    // 	var i = (currentSlide ? currentSlide : 0) + 1;
    // 	var ofCopy = '<span class="of-copy"> of </span>';
    //     $status0.html(i + ofCopy + slick.slideCount); 
    // });
    // $('.slides-trio').slick({
    //     arrows: true,
    //     dots: false,
    //     autoplay: false,
    //     autoplaySpeed: 4000,
    //     speed: 500, 
    //     fade: true, 
    //     accessibility: false,
    //     prevArrow: $('.prev-gallery-1'),
	// 	nextArrow: $('.next-gallery-1')
    // });
    
    // var $status1 = $('.pagingInfo-1');
	// var $slickElement1 = $('.slides-trio-1'); 
	// $slickElement1.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    // 	//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    // 	var i = (currentSlide ? currentSlide : 0) + 1;
    // 	var ofCopy = '<span class="of-copy"> of </span>';
    //     $status1.html(i + ofCopy + slick.slideCount); 
    // });
    // $slickElement1.slick({
    //     arrows: true,
    //     dots: false,
    //     autoplay: false,
    //     autoplaySpeed: 4000,
    //     speed: 500, 
    //     fade: true, 
    //     accessibility: false,
    //     prevArrow: $('.prev-gallery'),
	// 	nextArrow: $('.next-gallery')
    // });
    
    var $status2 = $('.pagingInfo-2');
	var $slickElement2 = $('.slides-trio-2'); 
	$slickElement2.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    	//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    	var i = (currentSlide ? currentSlide : 0) + 1;
    	var ofCopy = '<span class="of-copy"> of </span>';
        $status2.html(i + ofCopy + slick.slideCount); 
    });
    $slickElement2.slick({
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 500, 
        fade: true, 
        accessibility: false,
        prevArrow: $('.prev-gallery'),
		nextArrow: $('.next-gallery')
    }); */
	
	/* $(".tabs-menu a").click(function(event) {
		$('.slides-trio').slick('unslick');
		$('.slides-trio-1').slick('unslick');
		$('.slides-trio-2').slick('unslick');
        event.preventDefault();
        $('.tabs-menu a').removeClass("active");
        $(this).addClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
    
    }); */
    
    //Booking engine
	$('.booking-holder select[name="property"]').on('change', function() {
		if( $(this).val().length > 5){
			$(".booking-holder form#booking-form").attr('action',$(this).val());
			$('.booking-holder form#booking-form input[type="text"], .booking-holder form#booking-form select:not(.property), .booking-holder form#booking-form input[type="hidden"]').prop("disabled", true);
			$('.booking-holder form#booking-form input[type="text"], .booking-holder form#booking-form select:not(.property)').addClass('inactive');
		}else{
			$('.booking-holder form#booking-form input[type="text"], .booking-holder form#booking-form select, .booking-holder form#booking-form input[type="hidden"]').prop("disabled", false);
			$('.booking-holder form#booking-form input[type="text"], .booking-holder form#booking-form select:not(.property)').removeClass('inactive');
			$(".booking-holder form#booking-form").attr('action','https://gc.synxis.com/rez.aspx?');
		}
		$('input[name="Hotel"]').val($(this).val());
	});
	$(".booking-holder form#booking-form").submit(function(e){
		if( $('input[name="Hotel"]').val() == ''){
			e.preventDefault(e)
			$('.booking-holder .error-msg').fadeIn();
			setTimeout(function(){ $('.booking-holder .error-msg').fadeOut(); }, 3000);
		}
	});
    
	//Booking engine home
	$('.booking select[name="property"]').on('change', function() {
		if( $(this).val().length > 5){
			$(".booking form#booking-form-2").attr('action',$(this).val());
			$('.booking form#booking-form-2 input[type="text"], .booking form#booking-form-2 select:not(.property), .booking form#booking-form-2 input[type="hidden"]').prop("disabled", true);
			$('.booking form#booking-form-2 input[type="text"], .booking form#booking-form-2 select:not(.property)').addClass('inactive');
		}else{
			$('.booking form#booking-form-2 input[type="text"], .booking form#booking-form-2 select, .booking form#booking-form-2 input[type="hidden"]').prop("disabled", false);
			$('.booking form#booking-form-2 input[type="text"], .booking form#booking-form-2 select:not(.property)').removeClass('inactive');
			$(".booking form#booking-form-2").attr('action','https://gc.synxis.com/rez.aspx?');
		}
		$('input[name="Hotel"]').val($(this).val());
	});
	$(".booking form#booking-form-2").submit(function(e){
		if( $('input[name="Hotel"]').val() == ''){
			e.preventDefault(e)
			$('.booking .error-msg').fadeIn();
			setTimeout(function(){ $('.booking .error-msg').fadeOut(); }, 3000);
		}
	});
	
	//Booking engine associate
	$('.booking select[name="property"]').on('change', function() {
		if( $(this).val().length > 5){
			$(".booking form#booking-form-3").attr('action',$(this).val());
			$('.booking form#booking-form-3 input[type="text"], .booking form#booking-form-3 select:not(.property), .booking form#booking-form-3 input[type="hidden"]').prop("disabled", true);
			$('.booking form#booking-form-3 input[type="text"], .booking form#booking-form-3 select:not(.property)').addClass('inactive');
		}else{
			$('.booking form#booking-form-3 input[type="text"], .booking form#booking-form-3 select, .booking form#booking-form-3 input[type="hidden"]').prop("disabled", false);
			$('.booking form#booking-form-3 input[type="text"], .booking form#booking-form-3 select:not(.property)').removeClass('inactive');
			$(".booking form#booking-form-3").attr('action','https://gc.synxis.com/rez.aspx?');
		}
		$('input[name="Hotel"]').val($(this).val());
	});
	$(".booking form#booking-form-3").submit(function(e){
		if( $('input[name="Hotel"]').val() == ''){
			e.preventDefault(e)
			$('.booking .error-msg').fadeIn();
			setTimeout(function(){ $('.booking .error-msg').fadeOut(); }, 3000);
		}
	});

	//Event Tracking
/*
    $('.book-now').on('click', function () {
         ga('send', 'event', 'reservations', 'click', 'book now');
    });
    
*/


    $('.close-booking').click(function(){
	    $('.booking-holder').fadeOut();
    });
    
    $(".datepicker-promo").datepicker({
		minDate: 0,
		numberOfMonths: [2,1],
		beforeShowDay: function(date) {
			var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckIn").val());
			var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckOut").val());
			return [true, date1 && ((date.getTime() == date1.getTime()) || (date2 && date >= date1 && date <= date2)) ? "dp-highlight" : ""];
		},
		onSelect: function(dateText, inst) {
			var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckIn").val());
			var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckOut").val());
            var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, dateText);
            
            if (!date1 || date2) {
				$("#CheckIn").val(dateText);
				$("#CheckOut").val("");
                $(this).datepicker();
            } else if( selectedDate < date1 ) {
                $("#CheckOut").val( $("#CheckIn").val() );
                $("#CheckIn").val(dateText);
                $(this).datepicker();
            } else {
				$("#CheckOut").val(dateText);
                $(this).datepicker();
			}
		}
	});
	
	//Check in and check out datepicker for booking engine
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		numberOfMonths: [2,1],
		onSelect: function( selectedDate ) {
			getDate = $(this).datepicker('getDate');
        	newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	
	$('#CheckOut').on('change',function(){
     var days = (daydiff(parseDate($('#CheckIn').val()), parseDate($('#CheckOut').val())));
      $('.days').html('you selected a total of '+days);
      
    });
    
    function parseDate(str) {
    var mdy = str.split('/')
    return new Date(mdy[2], mdy[0]-1, mdy[1]);

}

function daydiff(first, second) {
    return (second-first)/(1000*60*60*24);
}
	
	//Check in and check out datepicker for booking engine
	$( "#CheckIn-2" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			var getDate = $(this).datepicker('getDate');
        	var newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut-2" ).datepicker( "setDate", newDate );
			$( "#CheckOut-2" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut-2" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn-2" ).datepicker( "option", "maxDate", selectedDate );
		}
	});


	$( "#CheckIn-home" ).datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			var getDate = $(this).datepicker('getDate');
        	var newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut-home" ).datepicker( "setDate", newDate );
			$( "#CheckOut-home" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut-home" ).datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn-home" ).datepicker( "option", "maxDate", selectedDate );
		}
	});

	$('#property-2').change(function(event) {
		//console.log();
		$('#booking-form-2 input[name="Hotel"]').attr('value',$(this).val())
	});
	
	//Check in and check out datepicker for booking engine
	$( "#CheckIn-3" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			getDate = $(this).datepicker('getDate');
        	newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut-3" ).datepicker( "setDate", newDate );
			$( "#CheckOut-3" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut-3" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn-3" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
});

$(window).on("load", function () {
	equalize();
	resizeWindow();
});

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
